export const skillsCz = {
  skillCategories: {
    programming: 'Programování',
    web_development: 'Webový vývoj',
    backend: 'Backend vývoj',
    database: 'Databáze',
    devops: 'DevOps & Cloud',
    mobile: 'Mobilní vývoj',
    design: 'Design & Kreativa',
    office: 'Kancelář & Administrativa',
    project_management: 'Projektové řízení',
    data_science: 'Datová věda & Analytika',
    marketing: 'Marketing & Reklama',
    sales: 'Prodej & Obchodní rozvoj',
    soft_skills: 'Měkké dovednosti',
    finance: 'Finance & Účetnictví',
    healthcare: 'Zdravotnictví',
    logistics: 'Logistika & Dodavatelský řetězec',
    manufacturing: 'Výroba & Produkce',
    electrical: 'Elektrotechnika & Elektronika',
    automotive: 'Automobilový průmysl',
    construction: 'Stavebnictví & Výstavba',
    agriculture: 'Zemědělství & Farmářství',
    hospitality: 'Pohostinství & Cestovní ruch',
    legal: 'Právní & Právo',
    education: 'Vzdělávání & Učení',
    environment: 'Životní prostředí & Udržitelnost',
    quality_management: 'Řízení kvality',
    hr: 'Lidské zdroje',
    safety: 'Bezpečnost & Compliance',
    other: 'Ostatní',
  },
  skills: {
    // Existující dovednosti
    ms_word: 'Microsoft Word',
    ms_excel: 'Microsoft Excel',
    ms_powerpoint: 'Microsoft PowerPoint',
    autodesk: 'AutoDesk',
    corel_draw: 'Corel Draw',
    canva: 'Canva',
    adobe: 'Adobe',
    sap: 'SAP',
    salesforce: 'Salesforce',
    trello: 'Trello',
    angular: 'Angular',
    blockchain: 'Blockchain',
    c: 'C',
    cpp: 'C++',
    csharp: 'C#',
    java: 'Java',
    python: 'Python',
    ios: 'iOS',
    dotnet: '.NET',
    php: 'PHP',
    plc: 'PLC programování',

    // Programovací jazyky
    javascript: 'JavaScript',
    typescript: 'TypeScript',
    golang: 'Go (Golang)',
    rust: 'Rust',
    ruby: 'Ruby',
    kotlin: 'Kotlin',
    swift: 'Swift',
    scala: 'Scala',
    r_language: 'R',
    perl: 'Perl',
    dart: 'Dart',
    elixir: 'Elixir',
    haskell: 'Haskell',
    assembly: 'Assembly',
    matlab: 'MATLAB',

    // Webový vývoj
    react: 'React',
    vuejs: 'Vue.js',
    nextjs: 'Next.js',
    nuxtjs: 'Nuxt.js',
    svelte: 'Svelte',
    html5: 'HTML5',
    css3: 'CSS3',
    sass: 'Sass/SCSS',
    tailwind: 'Tailwind CSS',
    bootstrap: 'Bootstrap',
    material_ui: 'Material UI',
    jquery: 'jQuery',
    webpack: 'Webpack',
    vite: 'Vite',
    redux: 'Redux',
    graphql: 'GraphQL',
    rest_api: 'REST API',
    websockets: 'WebSockets',

    // Backend
    nodejs: 'Node.js',
    expressjs: 'Express.js',
    django: 'Django',
    flask: 'Flask',
    fastapi: 'FastAPI',
    spring_boot: 'Spring Boot',
    laravel: 'Laravel',
    ruby_on_rails: 'Ruby on Rails',
    aspnet_core: 'ASP.NET Core',
    gin_go: 'Gin (Go)',
    nestjs: 'NestJS',
    symfony: 'Symfony',
    codeigniter: 'CodeIgniter',

    // Databáze
    postgresql: 'PostgreSQL',
    mysql: 'MySQL',
    mongodb: 'MongoDB',
    redis: 'Redis',
    elasticsearch: 'Elasticsearch',
    sqlite: 'SQLite',
    mariadb: 'MariaDB',
    mssql: 'Microsoft SQL Server',
    oracle_db: 'Oracle Database',
    dynamodb: 'DynamoDB',
    cassandra: 'Cassandra',
    couchdb: 'CouchDB',
    firebase: 'Firebase',
    supabase: 'Supabase',
    neo4j: 'Neo4j',

    // DevOps
    docker: 'Docker',
    kubernetes: 'Kubernetes',
    aws: 'AWS (Amazon Web Services)',
    azure: 'Microsoft Azure',
    gcp: 'Google Cloud Platform',
    terraform: 'Terraform',
    ansible: 'Ansible',
    jenkins: 'Jenkins',
    gitlab_cicd: 'GitLab CI/CD',
    github_actions: 'GitHub Actions',
    circleci: 'CircleCI',
    git: 'Git',
    linux: 'Linux',
    nginx: 'Nginx',
    apache: 'Apache',
    prometheus: 'Prometheus',
    grafana: 'Grafana',
    elk_stack: 'ELK Stack',

    // Mobilní
    react_native: 'React Native',
    flutter: 'Flutter',
    android: 'Vývoj pro Android',
    ios_dev: 'Vývoj pro iOS',
    swiftui: 'SwiftUI',
    jetpack_compose: 'Jetpack Compose',
    xamarin: 'Xamarin',
    ionic: 'Ionic',
    cordova: 'Cordova',

    // Design
    figma: 'Figma',
    photoshop: 'Adobe Photoshop',
    illustrator: 'Adobe Illustrator',
    adobe_xd: 'Adobe XD',
    indesign: 'Adobe InDesign',
    premiere_pro: 'Adobe Premiere Pro',
    after_effects: 'Adobe After Effects',
    sketch: 'Sketch',
    invision: 'InVision',
    ui_ux_design: 'UI/UX Design',
    graphic_design: 'Grafický design',
    video_editing: 'Střih videa',
    '3d_modeling': '3D modelování',
    blender: 'Blender',
    cinema_4d: 'Cinema 4D',
    procreate: 'Procreate',

    // Kancelář
    ms_office: 'Microsoft Office Suite',
    google_workspace: 'Google Workspace',
    excel_advanced: 'Excel pokročilý',
    data_entry: 'Zadávání dat',
    data_analysis: 'Analýza dat',
    typing_speed: 'Rychlost psaní',
    admin_support: 'Administrativní podpora',
    document_management: 'Správa dokumentů',

    // Projektové řízení
    agile: 'Agile',
    scrum: 'Scrum',
    kanban: 'Kanban',
    jira: 'Jira',
    asana: 'Asana',
    monday: 'Monday.com',
    ms_project: 'Microsoft Project',
    confluence: 'Confluence',
    notion: 'Notion',
    basecamp: 'Basecamp',

    // Datová věda
    machine_learning: 'Strojové učení',
    deep_learning: 'Hluboké učení',
    tensorflow: 'TensorFlow',
    pytorch: 'PyTorch',
    pandas: 'Pandas',
    numpy: 'NumPy',
    scikit_learn: 'Scikit-learn',
    nlp: 'Zpracování přirozeného jazyka (NLP)',
    computer_vision: 'Počítačové vidění',
    data_visualization: 'Vizualizace dat',
    tableau: 'Tableau',
    power_bi: 'Power BI',
    jupyter: 'Jupyter Notebooks',
    statistics: 'Statistika',
    ab_testing: 'A/B testování',

    // Marketing
    seo: 'SEO (Optimalizace pro vyhledávače)',
    sem: 'SEM (Marketing ve vyhledávačích)',
    google_ads: 'Google Ads',
    facebook_ads: 'Facebook Ads',
    social_media_marketing: 'Marketing na sociálních sítích',
    content_marketing: 'Obsahový marketing',
    email_marketing: 'E-mailový marketing',
    copywriting: 'Copywriting',
    google_analytics: 'Google Analytics',
    marketing_automation: 'Marketingová automatizace',
    hubspot: 'HubSpot',
    mailchimp: 'Mailchimp',
    brand_management: 'Správa značky',
    influencer_marketing: 'Influencer marketing',

    // Prodej
    crm_systems: 'CRM systémy',
    cold_calling: 'Studené volání',
    lead_generation: 'Generování leadů',
    negotiation: 'Vyjednávání',
    sales_pipeline: 'Správa prodejního řetězce',
    b2b_sales: 'B2B prodej',
    b2c_sales: 'B2C prodej',
    account_management: 'Správa účtů',
    customer_relationship: 'Řízení vztahů se zákazníky',
    sales_presentations: 'Prodejní prezentace',

    // Měkké dovednosti
    leadership: 'Vedení',
    team_management: 'Řízení týmu',
    communication: 'Komunikace',
    public_speaking: 'Veřejné vystupování',
    presentation_skills: 'Prezentační dovednosti',
    problem_solving: 'Řešení problémů',
    critical_thinking: 'Kritické myšlení',
    time_management: 'Řízení času',
    organization: 'Organizace',
    teamwork: 'Týmová práce',
    collaboration: 'Spolupráce',
    adaptability: 'Adaptabilita',
    creativity: 'Kreativita',
    conflict_resolution: 'Řešení konfliktů',
    decision_making: 'Rozhodování',
    emotional_intelligence: 'Emoční inteligence',
    work_ethic: 'Pracovní morálka',
    attention_to_detail: 'Pozornost k detailu',

    // Finance
    accounting: 'Účetnictví',
    financial_analysis: 'Finanční analýza',
    bookkeeping: 'Vedení účetnictví',
    quickbooks: 'QuickBooks',
    xero: 'Xero',
    tax_preparation: 'Příprava daní',
    budgeting: 'Rozpočtování',
    financial_reporting: 'Finanční výkaznictví',
    auditing: 'Audit',
    payroll: 'Zpracování mezd',

    // Zdravotnictví
    medical_terminology: 'Lékařská terminologie',
    patient_care: 'Péče o pacienty',
    emr: 'Elektronické zdravotní záznamy (EMR)',
    cpr: 'Certifikace CPR',
    first_aid: 'První pomoc',
    vital_signs: 'Monitorování životních funkcí',
    medication_admin: 'Podávání léků',
    medical_coding: 'Lékařské kódování',
    healthcare_compliance: 'Compliance ve zdravotnictví',
    hipaa: 'Znalost HIPAA',

    // Logistika
    supply_chain: 'Řízení dodavatelského řetězce',
    warehouse_management: 'Správa skladu',
    inventory_control: 'Kontrola zásob',
    forklift: 'Obsluha vysokozdvižného vozíku',
    shipping_receiving: 'Expedice & Příjem',
    logistics_coordination: 'Koordinace logistiky',
    quality_control: 'Kontrola kvality',
    route_planning: 'Plánování tras',
    procurement: 'Nákup',
    wms_software: 'WMS software',

    // Nové dovednosti z migrace 56 (seřazeno abecedně)
    '3d_visualization': '3D vizualizace',
    abap: 'ABAP',
    academic_supervision: 'Akademický dohled',
    access_control: 'Řízení přístupu',
    access_control_systems: 'Systémy řízení přístupu',
    accounting_software: 'Účetní software',
    acoustics: 'Akustika',
    active_listening: 'Aktivní naslouchání',
    activity_planning: 'Plánování aktivit',
    actuarial_software: 'Aktuárský software',
    adaptive_teaching: 'Adaptivní učení',
    adas_recalibration: 'ADAS rekalibrce',
    adhesive_application: 'Aplikace lepidel',
    administrative_law: 'Správní právo',
    advanced_nursing: 'Pokročilé ošetřovatelství',
    adverse_event_reporting: 'Hlášení nežádoucích událostí',
    advertising_sales: 'Prodej reklamy',
    advisory_services: 'Poradenské služby',
    agricultural_law: 'Zemědělské právo',
    agricultural_machinery: 'Zemědělské stroje',
    agricultural_software: 'Zemědělský software',
    aircraft_systems: 'Letadlové systémy',
    alarm_systems: 'Poplašné systémy',
    alignment_equipment: 'Zařízení na nastavení geometrie',
    alterations: 'Úpravy',
    analytical_chemistry: 'Analytická chemie',
    analytics: 'Analytika',
    anatomy_knowledge: 'Znalost anatomie',
    android_studio: 'Android Studio',
    anesthesia: 'Anestezie',
    animal_handling: 'Manipulace se zvířaty',
    animal_husbandry: 'Chov zvířat',
    animal_nutrition: 'Výživa zvířat',
    animal_surgery: 'Veterinární chirurgie',
    animation: 'Animace',
    api_documentation: 'API dokumentace',
    applicant_tracking_systems: 'Systémy sledování uchazečů (ATS)',
    arc_welding: 'Obloukové svařování',
    architectural_design: 'Architektonický design',
    archival_procedures: 'Archivační postupy',
    art_history: 'Dějiny umění',
    aspen_plus: 'Aspen Plus',
    assembly_procedures: 'Montážní postupy',
    assessment: 'Hodnocení',
    audience_analysis: 'Analýza publika',
    audio_editing: 'Úprava zvuku',
    audio_engineering: 'Zvukové inženýrství',
    audit_procedures: 'Auditní postupy',
    autocad: 'AutoCAD',
    autocad_mep: 'AutoCAD MEP',
    automotive_diagnostics: 'Automobilová diagnostika',
    automotive_electronics: 'Automobilová elektronika',
    automotive_painting: 'Automobilové lakování',
    automotive_software: 'Automobilový software',
    award_presentations: 'Udělování ocenění',
    bakery_equipment: 'Pekárenská zařízení',
    bankruptcy_law: 'Konkursní právo',
    bar_operations: 'Provoz baru',
    batch_processing: 'Dávkové zpracování',
    battery_management: 'Správa baterií',
    behavioral_assessment: 'Behaviorální hodnocení',
    benefit_administration: 'Správa zaměstnaneckých výhod',
    beverage_service: 'Podávání nápojů',
    bidding: 'Veřejné zadávání',
    billing: 'Fakturace',
    bim: 'BIM',
    biochemistry: 'Biochemie',
    blueprint_reading: 'Čtení výkresů',
    boat_maintenance: 'Údržba lodí',
    body_repair: 'Oprava karoserie',
    bookbinding: 'Knihařství',
    brake_systems: 'Brzdové systémy',
    brand_development: 'Rozvoj značky',
    brewing: 'Vaření piva',
    broadcast_engineering: 'Vysílací inženýrství',
    building_codes: 'Stavební předpisy',
    building_maintenance: 'Údržba budov',
    building_regulations: 'Stavební nařízení',
    business_analysis: 'Obchodní analýza',
    business_law: 'Obchodní právo',
    cad_cam_dental: 'CAD/CAM dentální',
    cad_software: 'CAD software',
    calibration: 'Kalibrace',
    cam_software: 'CAM software',
    camera_operation: 'Obsluha kamery',
    campaign_management: 'Řízení kampaní',
    candidate_evaluation: 'Hodnocení kandidátů',
    candidate_screening: 'Screening kandidátů',
    candidate_sourcing: 'Vyhledávání kandidátů',
    cannabis_cultivation: 'Pěstování konopí',
    caregiver_support: 'Podpora pečovatelů',
    carpentry: 'Truhlářství',
    case_management: 'Správa případů',
    cash_handling: 'Manipulace s hotovostí',
    catia: 'CATIA',
    cctv_systems: 'CCTV systémy',
    ceramic_techniques: 'Keramické techniky',
    ceremony_planning: 'Plánování ceremonií',
    change_management: 'Řízení změn',
    chemical_engineering: 'Chemické inženýrství',
    chemical_handling: 'Manipulace s chemikáliemi',
    chemical_processes: 'Chemické procesy',
    chemistry: 'Chemie',
    child_development: 'Vývoj dítěte',
    child_nutrition: 'Výživa dětí',
    child_safety: 'Bezpečnost dětí',
    civil_3d: 'Civil 3D',
    civil_engineering: 'Stavební inženýrství',
    civil_law: 'Občanské právo',
    claim_processing: 'Zpracování pojistných událostí',
    class_management: 'Řízení tříd',
    classroom_management: 'Řízení třídy',
    cleaning_procedures: 'Čisticí postupy',
    client_counseling: 'Poradenství pro klienty',
    client_interaction: 'Interakce s klienty',
    climate_control: 'Klimatizace',
    clinical_documentation: 'Klinická dokumentace',
    clinical_protocols: 'Klinické protokoly',
    clinical_research: 'Klinický výzkum',
    clinical_skills: 'Klinické dovednosti',
    cloud_services: 'Cloudové služby',
    cnc_operation: 'Obsluha CNC',
    cnc_programming: 'CNC programování',
    cnc_setup: 'Nastavení CNC',
    coaching: 'Koučování',
    coating_application: 'Aplikace povlaků',
    cocktail_preparation: 'Příprava koktejlů',
    coding_standards: 'Kódovací standardy',
    cognitive_assessment: 'Kognitivní hodnocení',
    color_matching: 'Sladění barev',
    combustion_systems: 'Spalovací systémy',
    commercial_law: 'Obchodní právo',
    community_engagement: 'Zapojení komunity',
    community_outreach: 'Komunitní rozvoj',
    compensation_analysis: 'Analýza odměn',
    competitive_analysis: 'Konkurenční analýza',
    compiler_design: 'Návrh kompilátorů',
    compliance_auditing: 'Audit souladu',
    compliance_documentation: 'Dokumentace souladu',
    compliance_management: 'Řízení souladu',
    compliance_monitoring: 'Monitorování souladu',
    compliance_reporting: 'Reportování souladu',
    compliance_training: 'Školení o souladu',
    component_testing: 'Testování komponent',
    composting: 'Kompostování',
    computer_hardware: 'Počítačový hardware',
    concrete_work: 'Betonářské práce',
    conflict_management: 'Řízení konfliktů',
    constitutional_law: 'Ústavní právo',
    construction_management: 'Řízení výstavby',
    construction_safety: 'Bezpečnost na stavbě',
    content_creation: 'Tvorba obsahu',
    content_development: 'Vývoj obsahu',
    content_moderation: 'Moderování obsahu',
    continuous_improvement: 'Neustálé zlepšování',
    contract_drafting: 'Návrh smluv',
    contract_law: 'Smluvní právo',
    contract_negotiation: 'Vyjednávání smluv',
    control_systems: 'Řídicí systémy',
    corporate_law: 'Korporátní právo',
    corrective_actions: 'Nápravná opatření',
    cost_analysis: 'Nákladová analýza',
    cost_control: 'Kontrola nákladů',
    cost_estimation: 'Odhad nákladů',
    counseling: 'Poradenství',
    course_development: 'Vývoj kurzů',
    court_procedures: 'Soudní řízení',
    crane_operation: 'Obsluha jeřábu',
    creative_direction: 'Kreativní režie',
    credit_analysis: 'Úvěrová analýza',
    criminal_law: 'Trestní právo',
    crisis_intervention: 'Krizová intervence',
    crisis_management: 'Krizové řízení',
    critical_care: 'Intenzivní péče',
    crop_management: 'Správa plodin',
    crop_protection: 'Ochrana plodin',
    culinary_arts: 'Kulinářské umění',
    cultural_sensitivity: 'Kulturní citlivost',
    curriculum_design: 'Návrh učebních osnov',
    curriculum_development: 'Vývoj učebních osnov',
    custom_fabrication: 'Kusová výroba',
    customer_education: 'Vzdělávání zákazníků',
    customer_engagement: 'Zapojení zákazníků',
    customer_retention: 'Udržení zákazníků',
    customer_service: 'Zákaznický servis',
    customs_regulations: 'Celní předpisy',
    cutting_techniques: 'Techniky řezání',
    data_collection: 'Sběr dat',
    data_interpretation: 'Interpretace dat',
    data_management: 'Správa dat',
    database_design: 'Návrh databází',
    database_management: 'Správa databází',
    deal_negotiation: 'Vyjednávání obchodů',
    decision_support: 'Podpora rozhodování',
    decorating: 'Dekorování',
    demolition: 'Demolice',
    dental_equipment: 'Zubní zařízení',
    dental_hygiene: 'Dentální hygiena',
    dental_procedures: 'Zubní postupy',
    design_software: 'Designový software',
    design_thinking: 'Designové myšlení',
    desktop_support: 'Desktopová podpora',
    diagnostic_equipment: 'Diagnostická zařízení',
    diagnostic_imaging: 'Diagnostické zobrazování',
    diagnostic_testing: 'Diagnostické testování',
    diesel_engines: 'Dieselové motory',
    diet_planning: 'Plánování stravy',
    differentiated_instruction: 'Diferencované vyučování',
    digital_fabrication: 'Digitální výroba',
    digital_literacy: 'Digitální gramotnost',
    digital_marketing: 'Digitální marketing',
    disability_awareness: 'Povědomí o zdravotním postižení',
    disability_support: 'Podpora osob se zdravotním postižením',
    disaster_response: 'Reakce na katastrofy',
    disinfection: 'Dezinfekce',
    dispensing: 'Výdej léků',
    dispute_resolution: 'Řešení sporů',
    distribution_management: 'Řízení distribuce',
    document_control: 'Kontrola dokumentů',
    document_review: 'Kontrola dokumentů',
    dosage_calculation: 'Výpočet dávkování',
    drainage_systems: 'Odvodnňovací systémy',
    drawing_interpretation: 'Interpretace výkresů',
    drilling: 'Vrtání',
    drone_operation: 'Obsluha dronů',
    drug_interactions: 'Lékové interakce',
    drywall: 'Sádrokarton',
    due_diligence: 'Due diligence',
    e_learning: 'E-learning',
    ecg_interpretation: 'Interpretace EKG',
    educational_assessment: 'Vzdělávací hodnocení',
    educational_software: 'Vzdělávací software',
    educational_technology: 'Vzdělávací technologie',
    electrical_cad: 'Elektrické CAD',
    electrical_codes: 'Elektrické předpisy',
    electrical_installation: 'Elektroinstalace',
    electrical_maintenance: 'Údržba elektrických zařízení',
    electrical_systems: 'Elektrické systémy',
    electrical_testing: 'Testování elektrických zařízení',
    electrical_troubleshooting: 'Řešení problémů s elektřinou',
    electronic_assembly: 'Elektronická montáž',
    electronic_testing: 'Testování elektroniky',
    electronics_repair: 'Oprava elektroniky',
    embedded_systems: 'Vestavěné systémy',
    emergency_care: 'Urgentní péče',
    emergency_preparedness: 'Připravenost na nouzové situace',
    emergency_procedures: 'Nouzové postupy',
    emergency_response: 'Nouzová reakce',
    emissions_testing: 'Testování emisí',
    employee_engagement: 'Angažovanost zaměstnanců',
    employee_relations: 'Vztahy se zaměstnanci',
    employment_law: 'Pracovní právo',
    encryption: 'Šifrování',
    end_of_life_care: 'Paliativní péče',
    energy_efficiency: 'Energetická efektivnost',
    energy_management: 'Energetický management',
    engine_diagnostics: 'Diagnostika motoru',
    engine_repair: 'Oprava motoru',
    environmental_compliance: 'Environmentální soulad',
    environmental_impact: 'Environmentální dopad',
    environmental_law: 'Environmentální právo',
    environmental_monitoring: 'Environmentální monitorování',
    environmental_science: 'Environmentální věda',
    equipment_calibration: 'Kalibrace zařízení',
    equipment_inspection: 'Inspekce zařízení',
    equipment_maintenance: 'Údržba zařízení',
    equipment_operation: 'Obsluha zařízení',
    equipment_repair: 'Oprava zařízení',
    equipment_setup: 'Nastavení zařízení',
    ergonomics: 'Ergonomie',
    escalation_management: 'Řízení eskalace',
    estate_planning: 'Plánování dědictví',
    ethical_standards: 'Etické standardy',
    event_coordination: 'Koordinace událostí',
    event_planning: 'Plánování podujatí',
    evidence_collection: 'Sběr důkazů',
    evidence_handling: 'Manipulace s důkazy',
    excavation: 'Výkopové práce',
    exhibit_design: 'Návrh výstav',
    experimental_design: 'Návrh experimentů',
    facility_management: 'Správa zařízení',
    family_law: 'Rodinné právo',
    fashion_design: 'Módní design',
    fastening_systems: 'Upevňovací systémy',
    feasibility_studies: 'Studie proveditelnosti',
    feed_formulation: 'Formulace krmiv',
    feedback_analysis: 'Analýza zpětné vazby',
    feedback_collection: 'Sběr zpětné vazby',
    fermentation: 'Fermentace',
    fertilization: 'Hnojení',
    field_service: 'Terénní servis',
    filing_systems: 'Archivační systémy',
    film_production: 'Filmová produkce',
    filtration_systems: 'Filtrační systémy',
    financial_management: 'Finanční řízení',
    financial_modeling: 'Finanční modelování',
    financial_planning: 'Finanční plánování',
    fire_safety: 'Požární bezpečnost',
    fire_systems: 'Požární systémy',
    firewall_management: 'Správa firewallu',
    firmware_development: 'Vývoj firmwaru',
    fitting: 'Montáž',
    fixture_installation: 'Instalace svítidel',
    fleet_management: 'Správa vozového parku',
    flooring: 'Podlahy',
    food_handling: 'Manipulace s potravinami',
    food_preparation: 'Příprava jídel',
    food_safety: 'Bezpečnost potravin',
    food_service: 'Stravovací služby',
    forecasting: 'Prognózování',
    forensic_analysis: 'Forenzní analýza',
    formulation: 'Formulace',
    foundation_work: 'Základové práce',
    framing: 'Konstrukce kostry',
    freight_handling: 'Manipulace s nákladem',
    front_desk: 'Recepce',
    front_end_alignment: 'Nastavení přední geometrie',
    fuel_systems: 'Palivové systémy',
    fundraising: 'Fundraising',
    furniture_assembly: 'Montáž nábytku',
    furniture_design: 'Návrh nábytku',
    g_code: 'G-kód',
    garment_construction: 'Konstrukce oděvů',
    gdpr: 'GDPR',
    gem_identification: 'Identifikace drahokamů',
    geriatric_care: 'Geriatrická péče',
    glass_installation: 'Instalace skla',
    glazing: 'Zasklívání',
    gmp: 'GMP',
    grant_writing: 'Psaní grantů',
    graphic_software: 'Grafický software',
    greenhouse_management: 'Správa skleníků',
    grief_counseling: 'Poradenství v truchlení',
    grinding: 'Broušení',
    grooming: 'Grooming',
    groundwater_monitoring: 'Monitorování podzemních vod',
    group_facilitation: 'Facilitace skupin',
    group_therapy: 'Skupinová terapie',
    guest_relations: 'Vztahy s hosty',
    guest_services: 'Služby pro hosty',
    hand_tools: 'Ruční nářadí',
    handling_techniques: 'Techniky manipulace',
    hardware_installation: 'Instalace hardwaru',
    hardware_troubleshooting: 'Řešení problémů s hardwarem',
    harvest_management: 'Řízení úrody',
    hazardous_materials: 'Nebezpečné látky',
    hazmat: 'HAZMAT',
    health_education: 'Zdravotní výchova',
    health_informatics: 'Zdravotnická informatika',
    health_promotion: 'Podpora zdraví',
    health_screening: 'Zdravotní screening',
    hearing_tests: 'Sluchové testy',
    heat_treatment: 'Tepelné zpracování',
    heating_systems: 'Vytápěcí systémy',
    heavy_equipment: 'Těžká technika',
    help_desk: 'Help desk',
    herd_management: 'Řízení stáda',
    historical_research: 'Historický výzkum',
    horticulture: 'Zahradnictví',
    hospitality_management: 'Řízení pohostinství',
    housekeeping: 'Úklid',
    hr_analytics: 'HR analytika',
    hr_policies: 'HR politiky',
    hr_software: 'HR software',
    hvac: 'HVAC',
    hvac_design: 'Návrh HVAC',
    hvac_installation: 'Instalace HVAC',
    hvac_systems: 'HVAC systémy',
    hydraulic_systems: 'Hydraulické systémy',
    hygiene_protocols: 'Hygienické protokoly',
    ict_integration: 'Integrace ICT',
    illustration: 'Ilustrace',
    image_processing: 'Zpracování obrazu',
    imaging_equipment: 'Zobrazovací zařízení',
    immigration_law: 'Imigrační právo',
    immunization: 'Imunizace',
    impact_assessment: 'Posouzení dopadu',
    incident_investigation: 'Vyšetřování incidentů',
    incident_management: 'Řízení incidentů',
    incident_reporting: 'Hlášení incidentů',
    inclusive_education: 'Inkluzivní vzdělávání',
    individual_education_plans: 'Individuální vzdělávací plány',
    industrial_automation: 'Průmyslová automatizace',
    industrial_design: 'Průmyslový design',
    industrial_equipment: 'Průmyslová zařízení',
    industrial_maintenance: 'Průmyslová údržba',
    infection_control: 'Kontrola infekcí',
    infusion_therapy: 'Infuzní terapie',
    injection_molding: 'Vstřikování plastů',
    inspection_procedures: 'Inspekční postupy',
    installation_procedures: 'Instalační postupy',
    instructional_design: 'Návrh vzdělávání',
    instrument_calibration: 'Kalibrace přístrojů',
    instrumentation: 'Přístrojová technika',
    insulation: 'Izolace',
    insurance_law: 'Pojišťovací právo',
    integration_testing: 'Integrační testování',
    intellectual_property: 'Duševní vlastnictví',
    interactive_learning: 'Interaktivní učení',
    interior_design: 'Interiérový design',
    interpreting: 'Tlumočení',
    interview_techniques: 'Techniky interview',
    interviewing: 'Vedení interview',
    inventory_management: 'Správa zásob',
    investment_analysis: 'Investiční analýza',
    irrigation: 'Zavlažování',
    irrigation_systems: 'Zavlažovací systémy',
    iso_9001: 'ISO 9001',
    jewelry_making: 'Výroba šperků',
    jewelry_repair: 'Oprava šperků',
    job_analysis: 'Analýza pracovních pozic',
    job_costing: 'Kalkulace zakázek',
    labor_law: 'Pracovní právo',
    labor_relations: 'Pracovní vztahy',
    laboratory_equipment: 'Laboratorní zařízení',
    laboratory_procedures: 'Laboratorní postupy',
    laboratory_techniques: 'Laboratorní techniky',
    landscape_design: 'Krajinářský design',
    landscape_maintenance: 'Údržba zeleně',
    language_instruction: 'Jazyková výuka',
    lathe_operation: 'Obsluha soustruhu',
    laundry_operations: 'Prádelna',
    layout_design: 'Návrh rozložení',
    lean_principles: 'Lean principy',
    learning_assessment: 'Hodnocení učení',
    learning_disabilities: 'Poruchy učení',
    legal_compliance: 'Právní soulad',
    legal_documentation: 'Právní dokumentace',
    legal_research: 'Právní výzkum',
    legal_writing: 'Právní psaní',
    lesson_planning: 'Plánování vyučovacích hodin',
    library_management: 'Správa knihoven',
    library_systems: 'Knihovní systémy',
    licensing: 'Licencování',
    lifting_equipment: 'Zdvihací zařízení',
    lighting_design: 'Světelný design',
    lighting_systems: 'Osvětlovací systémy',
    literature_review: 'Literární rešerše',
    litigation: 'Soudní spory',
    livestock_management: 'Řízení hospodářských zvířat',
    load_calculation: 'Výpočet zatížení',
    loan_processing: 'Zpracování úvěrů',
    lockout_tagout: 'Lockout/Tagout',
    logistics_planning: 'Logistické plánování',
    loss_prevention: 'Prevence ztrát',
    low_voltage_systems: 'Nízkopěťové systémy',
    lubrication: 'Mazání',
    machine_learning_engineering: 'Strojové učení - inženýrství',
    machine_operation: 'Obsluha strojů',
    machine_setup: 'Nastavení strojů',
    machining_processes: 'Obráběcí procesy',
    maintenance_planning: 'Plánování údržby',
    maintenance_procedures: 'Postupy údržby',
    makeup_application: 'Aplikace make-upu',
    manufacturing_processes: 'Výrobní procesy',
    maritime_law: 'Námořní právo',
    market_analysis: 'Tržní analýza',
    market_research: 'Průzkum trhu',
    masonry: 'Zednictví',
    massage_therapy: 'Masážní terapie',
    materials_handling: 'Manipulace s materiály',
    materials_science: 'Materiálové inženýrství',
    materials_selection: 'Výběr materiálů',
    measurement_techniques: 'Měřicí techniky',
    mechanical_assembly: 'Mechanická montáž',
    mechanical_design: 'Mechanický design',
    mechanical_systems: 'Mechanické systémy',
    media_relations: 'Vztahy s médii',
    medical_billing: 'Zdravotní fakturace',
    medical_documentation: 'Lékařská dokumentace',
    medical_equipment: 'Lékařská zařízení',
    medical_imaging: 'Lékařské zobrazování',
    medical_records: 'Zdravotní záznamy',
    medical_software: 'Zdravotnický software',
    medication_dispensing: 'Výdej léků',
    medication_management: 'Správa léků',
    membership_management: 'Správa členství',
    mental_health: 'Duševní zdraví',
    menu_development: 'Vývoj menu',
    menu_planning: 'Plánování menu',
    merchandising: 'Merchandising',
    metal_fabrication: 'Kovozpracování',
    metalworking: 'Kovoobrábění',
    microbiology: 'Mikrobiologie',
    mig_welding: 'MIG svařování',
    milling: 'Frézování',
    mixing: 'Míchání',
    mobile_development: 'Mobilní vývoj',
    mobile_repair: 'Oprava mobilů',
    mortuary_services: 'Pohřební služby',
    motor_control: 'Řízení motorů',
    motor_repair: 'Oprava motorů',
    multimedia_production: 'Multimediální produkce',
    museum_education: 'Muzejní pedagogika',
    music_education: 'Hudební výchova',
    music_performance: 'Hudební vystoupení',
    music_production: 'Hudební produkce',
    music_theory: 'Hudební teorie',
    narrative_writing: 'Narativní psaní',
    network_administration: 'Správa sítí',
    network_configuration: 'Konfigurace sítí',
    network_design: 'Návrh sítí',
    network_installation: 'Instalace sítí',
    network_maintenance: 'Údržba sítí',
    network_monitoring: 'Monitorování sítí',
    network_security: 'Síťová bezpečnost',
    network_troubleshooting: 'Řešení síťových problémů',
    neurological_assessment: 'Neurologické vyšetření',
    news_writing: 'Novinářské psaní',
    nonprofit_management: 'Řízení neziskových organizací',
    notary_services: 'Notářské služby',
    nursery_management: 'Řízení školky',
    nursing_assessment: 'Ošetřovatelské vyšetření',
    nutrition_counseling: 'Výživové poradenství',
    objective_c: 'Objective-C',
    occupational_health: 'Pracovní zdraví',
    occupational_therapy: 'Pracovní terapie',
    oil_analysis: 'Analýza olejů',
    onboarding: 'Onboarding',
    operating_systems: 'Operační systémy',
    operational_efficiency: 'Provozní efektivnost',
    operations_management: 'Řízení provozu',
    optical_systems: 'Optické systémy',
    order_fulfillment: 'Vyřizování objednávek',
    order_processing: 'Zpracování objednávek',
    organic_chemistry: 'Organická chemie',
    organic_farming: 'Ekologické zemědělství',
    organizational_development: 'Organizační rozvoj',
    orthodontics: 'Ortodoncie',
    orthopedics: 'Ortopedie',
    packaging: 'Balení',
    packaging_design: 'Design obalů',
    pain_management: 'Řízení bolesti',
    painting: 'Malování',
    palliative_care: 'Paliativní péče',
    paramedic_care: 'Zdravotnická záchranná služba',
    parent_communication: 'Komunikace s rodiči',
    parking_management: 'Správa parkování',
    parts_management: 'Správa náhradních dílů',
    pastry_arts: 'Cukrářství',
    patent_law: 'Patentové právo',
    pathology: 'Patologie',
    patient_assessment: 'Vyšetření pacienta',
    patient_communication: 'Komunikace s pacienty',
    patient_education: 'Vzdělávání pacientů',
    patient_monitoring: 'Monitorování pacientů',
    patient_scheduling: 'Plánování pacientů',
    pattern_making: 'Střihování',
    payroll_administration: 'Správa mezd',
    pcb_design: 'Návrh PCB',
    pediatric_care: 'Pediatrická péče',
    performance_evaluation: 'Hodnocení výkonu',
    performance_management: 'Řízení výkonu',
    performance_testing: 'Výkonnostní testování',
    permit_processing: 'Zpracování povolení',
    personal_training: 'Osobní trénink',
    pest_control: 'Ničení škůdců',
    pest_management: 'Řízení škůdců',
    pharmaceutical_calculations: 'Farmaceutické výpočty',
    pharmacology: 'Farmakologie',
    pharmacy_operations: 'Provoz lékárny',
    phlebotomy: 'Flebotomie',
    photography: 'Fotografování',
    physical_assessment: 'Fyzické vyšetření',
    physical_therapy: 'Fyzioterapie',
    physics: 'Fyzika',
    piping_systems: 'Potrubí',
    plan_review: 'Kontrola projektů',
    plant_operations: 'Provoz závodu',
    plasma_cutting: 'Plazmové řezání',
    plastering: 'Omítání',
    plc_programming: 'PLC programování',
    plsql: 'PL/SQL',
    plumbing: 'Instalatérství',
    plumbing_codes: 'Instalatérské předpisy',
    plumbing_systems: 'Instalatérské systémy',
    pneumatic_systems: 'Pneumatické systémy',
    point_of_sale: 'Pokladna',
    policy_analysis: 'Analýza politik',
    policy_development: 'Vývoj politik',
    pollination_management: 'Řízení opylování',
    pollution_control: 'Kontrola znečištění',
    polymer_science: 'Polymery',
    portfolio_management: 'Správa portfolia',
    pos_systems: 'POS systémy',
    post_production: 'Postprodukce',
    power_distribution: 'Distribuce energie',
    power_systems: 'Energetické systémy',
    power_tools: 'Elektrické nářadí',
    precision_machining: 'Přesné obrábění',
    precision_measurement: 'Přesné měření',
    predictive_maintenance: 'Prediktivní údržba',
    preventive_maintenance: 'Preventivní údržba',
    print_production: 'Tiskařská produkce',
    process_control: 'Řízení procesů',
    process_design: 'Návrh procesů',
    process_documentation: 'Dokumentace procesů',
    process_engineering: 'Procesní inženýrství',
    process_improvement: 'Zlepšování procesů',
    process_optimization: 'Optimalizace procesů',
    process_validation: 'Validace procesů',
    product_design: 'Návrh produktu',
    product_development: 'Vývoj produktu',
    product_knowledge: 'Znalost produktů',
    product_testing: 'Testování produktů',
    production_planning: 'Plánování výroby',
    production_scheduling: 'Rozvrhování výroby',
    program_evaluation: 'Hodnocení programů',
    program_management: 'Řízení programů',
    project_coordination: 'Koordinace projektů',
    project_documentation: 'Projektová dokumentace',
    project_planning: 'Plánování projektů',
    project_scheduling: 'Rozvrhování projektů',
    promotion_planning: 'Plánování propagace',
    proofreading: 'Korektury',
    property_law: 'Majetkové právo',
    property_maintenance: 'Údržba nemovitostí',
    property_management: 'Správa nemovitostí',
    proposal_writing: 'Psaní návrhů',
    prosthetics: 'Protetika',
    prototyping: 'Prototypování',
    psychiatric_care: 'Psychiatrická péče',
    psychological_assessment: 'Psychologické vyšetření',
    public_health: 'Veřejné zdraví',
    public_relations: 'Vztahy s veřejností',
    purchasing: 'Nákup',
    quality_assurance: 'Zajištění kvality',
    quality_documentation: 'Dokumentace kvality',
    quality_inspection: 'Kontrola kvality',
    quality_standards: 'Normy kvality',
    quality_systems: 'Systémy kvality',
    quality_testing: 'Testování kvality',
    quantity_surveying: 'Rozpočtářství',
    radiography: 'Radiografie',
    radiology: 'Radiologie',
    real_estate_law: 'Právo nemovitostí',
    receiving: 'Příjem zboží',
    recipe_development: 'Vývoj receptur',
    record_keeping: 'Vedení záznamů',
    recruitment: 'Nábor',
    recycling_programs: 'Recyklační programy',
    refrigeration: 'Chlazení',
    refrigeration_systems: 'Chladicí systémy',
    regulatory_affairs: 'Regulační záležitosti',
    regulatory_compliance: 'Regulační soulad',
    rehabilitation: 'Rehabilitace',
    reliability_engineering: 'Inženýrství spolehlivosti',
    remote_support: 'Vzdálená podpora',
    renewable_energy: 'Obnovitelné zdroje energie',
    repair_procedures: 'Opravné postupy',
    repair_techniques: 'Opravné techniky',
    report_writing: 'Psaní zpráv',
    reservation_systems: 'Rezervační systémy',
    residential_care: 'Rezidenční péče',
    resource_allocation: 'Alokace zdrojů',
    resource_management: 'Správa zdrojů',
    resource_planning: 'Plánování zdrojů',
    respiratory_care: 'Respirační péče',
    respiratory_therapy: 'Respirační terapie',
    restaurant_management: 'Řízení restaurace',
    restoration: 'Restaurování',
    retail_management: 'Řízení maloobchodu',
    retail_operations: 'Maloobchodní operace',
    revenue_management: 'Řízení příjmů',
    revit: 'Revit',
    rfid_systems: 'RFID systémy',
    risk_analysis: 'Analýza rizik',
    risk_assessment: 'Posouzení rizik',
    risk_management: 'Řízení rizik',
    robotics: 'Robotika',
    roofing: 'Pokrývačství',
    room_service: 'Pokojová služba',
    root_cause_analysis: 'Analýza hlavních příčin',
    safety_audits: 'Bezpečnostní audity',
    safety_equipment: 'Bezpečnostní vybavení',
    safety_inspections: 'Bezpečnostní inspekce',
    safety_procedures: 'Bezpečnostní postupy',
    safety_protocols: 'Bezpečnostní protokoly',
    safety_regulations: 'Bezpečnostní předpisy',
    safety_systems: 'Bezpečnostní systémy',
    safety_training: 'Bezpečnostní školení',
    salon_management: 'Řízení salonu',
    sample_preparation: 'Příprava vzorků',
    sanitation: 'Sanitace',
    sanitation_procedures: 'Sanitační postupy',
    sawing: 'Pílení',
    scada: 'SCADA',
    scaffolding: 'Lešení',
    scanning_equipment: 'Skenovací zařízení',
    scheduling: 'Plánování',
    schematic_design: 'Schématický návrh',
    schematic_reading: 'Čtení schémat',
    scope_management: 'Řízení rozsahu',
    scripting: 'Skriptování',
    sculptural_techniques: 'Sochařské techniky',
    security_assessment: 'Bezpečnostní posouzení',
    security_monitoring: 'Bezpečnostní monitorování',
    security_operations: 'Bezpečnostní operace',
    security_protocols: 'Bezpečnostní protokoly',
    security_systems: 'Bezpečnostní systémy',
    seed_selection: 'Výběr osiva',
    sensor_technology: 'Senzorová technologie',
    server_administration: 'Správa serverů',
    server_maintenance: 'Údržba serverů',
    service_coordination: 'Koordinace služeb',
    service_delivery: 'Poskytování služeb',
    service_documentation: 'Servisní dokumentace',
    service_management: 'Správa služeb',
    service_writing: 'Psaní servisní dokumentace',
    sewing: 'Šití',
    sheet_metal: 'Plechařství',
    sheet_metal_fabrication: 'Zpracování plechu',
    shelving: 'Regálové systémy',
    shipping: 'Expedice',
    signal_processing: 'Zpracování signálů',
    site_management: 'Řízení staveniště',
    site_preparation: 'Příprava staveniště',
    site_supervision: 'Stavební dohled',
    sketchup: 'SketchUp',
    skincare: 'Péče o pleť',
    social_media_management: 'Správa sociálních médií',
    social_services: 'Sociální služby',
    social_work: 'Sociální práce',
    software_architecture: 'Softwarová architektura',
    software_deployment: 'Nasazení softwaru',
    software_documentation: 'Softwarová dokumentace',
    software_integration: 'Integrace softwaru',
    software_testing: 'Testování softwaru',
    soil_analysis: 'Analýza půdy',
    soil_management: 'Správa půdy',
    solar_installation: 'Instalace solárních panelů',
    soldering: 'Pájení',
    solidworks: 'SolidWorks',
    sound_design: 'Zvukový design',
    sound_engineering: 'Zvukové inženýrství',
    spa_services: 'Spa služby',
    space_planning: 'Prostorové plánování',
    special_education: 'Speciální pedagogika',
    spectroscopy: 'Spektroskopie',
    speech_therapy: 'Logopedie',
    sports_coaching: 'Sportovní koučování',
    sports_medicine: 'Sportovní medicína',
    spray_painting: 'Stříkání barvou',
    stakeholder_engagement: 'Zapojení zainteresovaných stran',
    stakeholder_management: 'Řízení zainteresovaných stran',
    statistical_analysis: 'Statistická analýza',
    steam_systems: 'Parní systémy',
    steel_fabrication: 'Zpracování oceli',
    sterilization: 'Sterilizace',
    stock_management: 'Správa skladů',
    storage_management: 'Správa úložišť',
    storyboarding: 'Storyboarding',
    strategic_planning: 'Strategické plánování',
    stress_testing: 'Zátěžové testování',
    structural_analysis: 'Strukturální analýza',
    structural_design: 'Konstrukční návrh',
    student_assessment: 'Hodnocení studentů',
    student_counseling: 'Poradenství pro studenty',
    student_engagement: 'Angažovanost studentů',
    student_support: 'Podpora studentů',
    substance_abuse: 'Závislost na látkách',
    succession_planning: 'Plánování nástupnictví',
    supplier_management: 'Správa dodavatelů',
    supply_planning: 'Plánování dodávek',
    surface_preparation: 'Příprava povrchu',
    surgical_assistance: 'Chirurgická asistence',
    surgical_instruments: 'Chirurgické nástroje',
    surgical_procedures: 'Chirurgické postupy',
    surveillance_systems: 'Sledovací systémy',
    survey_design: 'Návrh průzkumů',
    surveying: 'Geodézie',
    suspension_systems: 'Systémy zavěšení',
    sustainability_practices: 'Udržitelné postupy',
    system_administration: 'Správa systémů',
    system_configuration: 'Konfigurace systémů',
    system_design: 'Návrh systémů',
    system_documentation: 'Systémová dokumentace',
    system_integration: 'Integrace systémů',
    system_maintenance: 'Údržba systémů',
    system_monitoring: 'Monitorování systémů',
    system_optimization: 'Optimalizace systémů',
    system_testing: 'Testování systémů',
    systems_analysis: 'Systémová analýza',
    talent_acquisition: 'Získávání talentů',
    talent_development: 'Rozvoj talentů',
    tax_law: 'Daňové právo',
    tax_planning: 'Daňové plánování',
    team_building: 'Budování týmu',
    team_coordination: 'Koordinace týmu',
    team_leadership: 'Vedení týmu',
    technical_documentation: 'Technická dokumentace',
    technical_drawing: 'Technické kreslení',
    technical_support: 'Technická podpora',
    technical_training: 'Technické školení',
    technical_writing: 'Technické psaní',
    technology_integration: 'Integrace technologií',
    telecommunications: 'Telekomunikace',
    telemedicine: 'Telemedicína',
    tenant_relations: 'Vztahy s nájemníky',
    testing_procedures: 'Testovací postupy',
    textile_design: 'Textilní design',
    textile_production: 'Textilní výroba',
    therapeutic_interventions: 'Terapeutické intervence',
    therapy_planning: 'Plánování terapie',
    thermal_systems: 'Tepelné systémy',
    threading: 'Závitování',
    tig_welding: 'TIG svařování',
    tile_installation: 'Instalace dlažby',
    tool_maintenance: 'Údržba nářadí',
    tooling: 'Nástroje',
    tort_law: 'Deliktní právo',
    tour_guiding: 'Průvodcovství',
    tourism_management: 'Řízení cestovního ruchu',
    training_delivery: 'Realizace školení',
    training_development: 'Vývoj školení',
    training_programs: 'Školicí programy',
    transaction_processing: 'Zpracování transakcí',
    transmission_repair: 'Oprava převodovky',
    transportation_management: 'Řízení dopravy',
    travel_coordination: 'Koordinace cestování',
    travel_planning: 'Plánování cestování',
    triage: 'Třídění pacientů',
    troubleshooting: 'Řešení problémů',
    turf_management: 'Správa trávníků',
    turning: 'Soustružení',
    tutoring: 'Doučování',
    typography: 'Typografie',
    ui_design: 'UI design',
    ultrasound: 'Ultrazvuk',
    upholstery: 'Čalounění',
    user_experience: 'Uživatelská zkušenost',
    user_interface: 'Uživatelské rozhraní',
    user_training: 'Školení uživatelů',
    utility_systems: 'Inženýrské sítě',
    ux_design: 'UX design',
    vaccination: 'Očkování',
    valve_maintenance: 'Údržba ventilů',
    vendor_management: 'Správa dodavatelů',
    ventilation: 'Větrání',
    ventilation_systems: 'Větrací systémy',
    version_control: 'Verzování',
    veterinary_medicine: 'Veterinární medicína',
    veterinary_nursing: 'Veterinární ošetřovatelství',
    veterinary_surgery: 'Veterinární chirurgie',
    video_production: 'Video produkce',
    vineyard_management: 'Řízení vinic',
    virtual_reality: 'Virtuální realita',
    vision_testing: 'Testování zraku',
    visual_arts: 'Výtvarné umění',
    visual_communication: 'Vizuální komunikace',
    visual_design: 'Vizuální design',
    visual_merchandising: 'Vizuální merchandising',
    vocabulary_development: 'Rozvoj slovní zásoby',
    volunteer_management: 'Řízení dobrovolníků',
    warehouse_operations: 'Skladové operace',
    waste_disposal: 'Likvidace odpadu',
    waste_management: 'Správa odpadu',
    wastewater_treatment: 'Čištění odpadních vod',
    water_quality: 'Kvalita vody',
    water_systems: 'Vodovodní systémy',
    water_treatment: 'Úprava vody',
    web_design: 'Webový design',
    wedding_planning: 'Plánování svatby',
    welding: 'Svařování',
    welding_codes: 'Svářečské normy',
    wellness_programs: 'Wellness programy',
    wildlife_management: 'Správa volně žijících živočichů',
    wind_energy: 'Větrná energie',
    wine_production: 'Výroba vína',
    wiring: 'Elektroinstalace',
    woodworking: 'Práce se dřevem',
    workforce_development: 'Rozvoj pracovní síly',
    workforce_planning: 'Plánování pracovní síly',
    wound_care: 'Péče o rány',
    writing_skills: 'Písemné dovednosti',
    x_ray: 'Rentgen',
    xcode: 'Xcode',
    youth_development: 'Rozvoj mládeže',
    zoning_regulations: 'Územní předpisy',

    // Zemědělství - Chybějící dovednosti
    breeding_programs: 'Šlechtitelské programy',
    breeding_techniques: 'Techniky šlechtění',
    chainsaw_operation: 'Obsluha motorové pily',
    combine_harvester: 'Obsluha kombajnu',
    crop_cultivation: 'Pěstování plodin',
    crop_planning: 'Plánování plodin',
    crop_science: 'Věda o plodinách',
    farm_management: 'Řízení farmy',
    farm_software: 'Software pro zemědělství',
    forest_inventory: 'Lesní inventář',
    forest_management: 'Lesní hospodářství',
    forest_protection: 'Ochrana lesa',
    forestry_planning: 'Plánování lesního hospodářství',
    gis_mapping: 'GIS mapování',
    gps_guidance: 'GPS navigace',
    harvesting_techniques: 'Techniky sklizně',
    irrigation_design: 'Návrh zavlažování',
    milk_quality_testing: 'Testování kvality mléka',
    milking_equipment: 'Dojící zařízení',
    pest_identification: 'Identifikace škůdců',
    plant_cultivation: 'Pěstování rostlin',
    precision_agriculture: 'Precizní zemědělství',
    pruning: 'Prořezávání',
    soil_testing: 'Testování půdy',
    timber_estimation: 'Odhad dřeva',
    timber_harvesting: 'Těžba dřeva',
    timber_measurement: 'Měření dřeva',
    tractor_operation: 'Obsluha traktoru',
    tree_identification: 'Identifikace stromů',

    // Automobilový průmysl - Chybějící dovednosti
    automotive_wiring: 'Automobilové elektroinstalace',
    battery_systems: 'Bateriové systémy',
    ecu_programming: 'Programování ECU',
    obd_diagnostics: 'OBD diagnostika',
    obd_scanner: 'OBD skener',
    vehicle_diagnostics: 'Diagnostika vozidel',

    // Marketing & Obsah - Chybějící dovednosti
    binding_equipment: 'Vázací zařízení',
    cinematography: 'Kinematografie',
    cms: 'CMS',
    cms_platforms: 'CMS platformy',
    color_grading: 'Barevná korekce',
    color_management: 'Správa barev',
    color_mixing: 'Míchání barev',
    color_theory: 'Teorie barev',
    composition: 'Kompozice',
    content_editing: 'Úprava obsahu',
    content_strategy: 'Obsahová strategie',
    creative_design: 'Kreativní design',
    creative_software: 'Kreativní software',
    creative_writing: 'Kreativní psaní',
    digital_art: 'Digitální umění',
    editorial_leadership: 'Redakční vedení',
    editorial_management: 'Redakční management',
    editorial_work: 'Redakční práce',
    fact_checking: 'Ověřování faktů',
    grammar: 'Gramatika',
    journalism: 'Žurnalistika',
    lighting: 'Osvětlení',
    lightroom: 'Lightroom',
    mixing_consoles: 'Mixážní pulty',
    multimedia_software: 'Multimediální software',
    news_judgment: 'Novinářský úsudek',
    opinion_writing: 'Psaní názorů',
    printing_equipment: 'Tiskařská zařízení',
    publishing_management: 'Řízení publikování',
    publishing_workflow: 'Publikační workflow',
    recording_equipment: 'Nahrávací technika',
    research: 'Výzkum',
    sound_engineer: 'Zvukový inženýr',
    style_guides: 'Stylové příručky',
    user_research: 'Uživatelský výzkum',

    // Logistika & Doprava - Chybějící dovednosti
    bus_driving: 'Řízení autobusu',
    cargo_truck_driving: 'Řízení nákladního auta',
    customs_documentation: 'Celní dokumentace',
    customs_inspection: 'Celní kontrola',
    customs_procedures: 'Celní postupy',
    customs_software: 'Celní software',
    forklift_certification: 'Certifikace na vysokozdvižný vozík',
    forklift_operation: 'Obsluha vysokozdvižného vozíku',
    freight_forwarding: 'Nákladní přeprava',
    import_export_regulations: 'Předpisy o dovozu/vývozu',
    international_shipping: 'Mezinárodní přeprava',
    load_handling: 'Manipulace s nákladem',
    loading_unloading: 'Nakládání/Vykládání',
    logistics_control: 'Logistická kontrola',
    logistics_management: 'Logistický management',
    logistics_software: 'Logistický software',
    logistics_strategy: 'Logistická strategie',
    material_handling: 'Manipulace s materiálem',
    order_picking: 'Komisování',
    package_handling: 'Manipulace s balíky',
    shipping_documentation: 'Přepravní dokumentace',
    shipping_procedures: 'Přepravní postupy',
    supply_chain_software: 'Software pro dodavatelský řetězec',
    tariff_classification: 'Tarifní klasifikace',
    traffic_planning: 'Plánování dopravy',
    transportation_engineering: 'Dopravní inženýrství',
    transportation_planning: 'Plánování dopravy',
    warehouse_management_systems: 'Systémy řízení skladů',
    delivery_driving: 'Rozvoz',
    delivery_services: 'Doručovací služby',
    dispatch_operations: 'Dispečerské operace',
    driving: 'Řízení vozidla',
    fleet_software: 'Software pro správu vozového parku',
    gps_navigation: 'GPS navigace',
    inventory_auditing: 'Audit zásob',
    inventory_systems: 'Systémy zásob',
    inventory_tracking: 'Sledování zásob',
    load_securing: 'Upevnění nákladu',
    public_transport_driving: 'Řízení veřejné dopravy',
    railway_operations: 'Železniční operace',
    railway_systems: 'Železniční systémy',
    route_knowledge: 'Znalosti tras',
    route_optimization: 'Optimalizace tras',
    stock_verification: 'Ověření zásob',
    train_operation: 'Obsluha vlaku',
    train_scheduling: 'Plánování vlaků',
    truck_driving: 'Řízení nákladního vozidla',
    vehicle_inspection: 'Kontrola vozidla',
    vehicle_maintenance: 'Údržba vozidla',

    // Právo - Chybějící dovednosti
    authentication: 'Autentifikace',
    case_law: 'Případové právo',
    case_management_software: 'Software pro správu případů',
    contract_management: 'Správa smluv',
    court_filing: 'Podávání soudních podání',
    enforcement_procedures: 'Výkonné řízení',
    legal_databases: 'Právní databáze',
    legal_judgment: 'Právní úsudek',
    legal_knowledge: 'Právní znalosti',
    legal_management: 'Právní management',
    legal_procedures: 'Právní postupy',
    legal_software: 'Právní software',
    notarial_procedures: 'Notářské postupy',
    regulatory_databases: 'Regulační databáze',
    regulatory_submissions: 'Regulační podání',
    trial_management: 'Řízení soudních řízení',

    // HR & Mzdy - Chybějící dovednosti
    compensation_planning: 'Plánování odměňování',
    hr_systems: 'HR systémy',
    linkedin_recruiting: 'LinkedIn nábor',
    payroll_processing: 'Zpracování mezd',
    payroll_software: 'Mzdový software',

    // Pohostinství & Kulinářství - Chybějící dovednosti
    baking: 'Pečení',
    beverage_preparation: 'Příprava nápojů',
    cake_decoration: 'Zdobení dortů',
    check_in_out: 'Check-in/Check-out',
    coffee_preparation: 'Příprava kávy',
    confectionery: 'Cukrářství',
    cooking_techniques: 'Kuchařské techniky',
    culinary_techniques: 'Kulinářské techniky',
    dough_preparation: 'Příprava těsta',
    espresso_machines: 'Espresso kávovary',
    food_beverage_management: 'Řízení stravování a nápojů',
    food_beverage_pairing: 'Párování jídel a nápojů',
    food_chemistry: 'Chemie potravin',
    haccp: 'HACCP',
    hotel_management_software: 'Hotelový manažerský software',
    kitchen_equipment: 'Kuchyňské vybavení',
    kitchen_management: 'Řízení kuchyně',
    knife_skills: 'Práce s nožem',
    local_knowledge: 'Místní znalosti',
    meat_cutting: 'Krájení masa',
    meat_preparation: 'Příprava masa',
    menu_knowledge: 'Znalosti menu',
    mixology: 'Mixologie',
    oven_operation: 'Obsluha trouby',
    pastry_making: 'Výroba pečiva',
    pizza_making: 'Výroba pizzy',
    pms_software: 'PMS software',
    recipe_following: 'Dodržování receptů',
    table_service: 'Stolní servis',
    wine_knowledge: 'Znalosti vín',
    wine_pairing: 'Párování vín',

    // Zdravotnictví & Medicína - Chybějící dovednosti
    basic_nursing: 'Základní ošetřovatelství',
    blood_analysis: 'Analýza krve',
    casting: 'Sádrování',
    cell_culture: 'Buněčné kultury',
    clinical_trials: 'Klinické zkoušky',
    compounding: 'Složení léků',
    ct_scan: 'CT vyšetření',
    delivery_assistance: 'Pomoc při porodu',
    dental_prosthetics: 'Zubní protézy',
    dental_software: 'Zubařský software',
    dental_surgery: 'Zubní chirurgie',
    dietary_guidelines: 'Dietní doporučení',
    elisa: 'ELISA',
    emergency_medical_care: 'Urgentní zdravotní péče',
    epidemiology: 'Epidemiologie',
    eye_examination: 'Vyšetření zraku',
    gcp_compliance: 'GCP shoda',
    health_programs: 'Zdravotní programy',
    hygiene_procedures: 'Hygienické postupy',
    hygiene_standards: 'Hygienické standardy',
    laboratory_analysis: 'Laboratorní analýza',
    laboratory_diagnostics: 'Laboratorní diagnostika',
    laboratory_samples: 'Laboratorní vzorky',
    language_assessment: 'Jazykové hodnocení',
    lens_fitting: 'Nasazení čoček',
    life_support: 'Podpora života',
    massage_techniques: 'Masážní techniky',
    medical_advisor: 'Lékařský poradce',
    medical_auditing: 'Lékařský audit',
    medical_diagnosis: 'Lékařská diagnóza',
    medical_knowledge: 'Lékařské znalosti',
    medical_procedures: 'Lékařské postupy',
    medical_writing: 'Lékařské psaní',
    medication_administration: 'Podávání léků',
    medication_reminders: 'Připomínky léků',
    microscopy: 'Mikroskopie',
    mri: 'MRI',
    nursing_auditing: 'Ošetřovatelský audit',
    nursing_management: 'Ošetřovatelský management',
    nutrition_planning: 'Plánování výživy',
    obstetrics: 'Porodnictví',
    optical_equipment: 'Optická zařízení',
    optical_measurements: 'Optická měření',
    orthopedic_devices: 'Ortopedické pomůcky',
    pacs_systems: 'PACS systémy',
    pcr: 'PCR',
    pharmaceutical_analysis: 'Farmaceutická analýza',
    pharmaceutical_auditing: 'Farmaceutický audit',
    pharmaceutical_handling: 'Manipulace s farmaceutiky',
    pharmaceutical_knowledge: 'Farmaceutické znalosti',
    pharmaceutical_products: 'Farmaceutické produkty',
    pharmacovigilance: 'Farmakovigilance',
    pharmacy_software: 'Lékárenský software',
    prenatal_care: 'Prenatální péče',
    prescription_determination: 'Určení receptu',
    prescription_verification: 'Ověření receptu',
    radiation_safety: 'Radiační bezpečnost',
    rehabilitation_techniques: 'Rehabilitační techniky',
    splinting: 'Dlahovací',
    therapeutic_exercises: 'Terapeutická cvičení',
    therapeutic_massage: 'Terapeutická masáž',
    therapeutic_techniques: 'Terapeutické techniky',
    treatment_planning: 'Plánování léčby',
    urinalysis: 'Analýza moči',
    vital_signs_monitoring: 'Monitorování životních funkcí',
    x_ray_operation: 'Obsluha rentgenu',

    // Finance & Bankovnictví - Chybějící dovednosti
    banking_operations: 'Bankovní operace',
    financial_advisory: 'Finanční poradenství',
    financial_instruments: 'Finanční nástroje',
    financial_markets: 'Finanční trhy',
    financial_mathematics: 'Finanční matematika',
    financial_products: 'Finanční produkty',
    investment_products: 'Investiční produkty',
    pricing_analysis: 'Analýza cen',
    banking_products: 'Bankovní produkty',
    banking_software: 'Bankovní software',
    claim_assessment: 'Posouzení nároků',
    collection_procedures: 'Inkasní procedury',
    credit_assessment: 'Úvěrové hodnocení',
    credit_scoring: 'Úvěrový skóring',
    insurance_operations: 'Pojišťovací operace',
    insurance_products: 'Pojišťovací produkty',
    insurance_software: 'Pojišťovací software',
    insurance_systems: 'Pojišťovací systémy',
    invoicing: 'Fakturace',
    leasing_operations: 'Leasingové operace',
    leasing_products: 'Leasingové produkty',
    lending_systems: 'Úvěrové systémy',
    mortgage_products: 'Hypoteční produkty',
    payment_processing: 'Zpracování plateb',
    policy_administration: 'Správa pojistek',
    policy_pricing: 'Oceňování pojistek',
    receivables_management: 'Správa pohledávek',
    reconciliation: 'Sladění',
    risk_evaluation: 'Hodnocení rizik',
    risk_modeling: 'Modelování rizik',
    risk_software: 'Software pro řízení rizik',
    settlement_procedures: 'Vyrovnávací procedury',
    swift_messaging: 'SWIFT zprávy',
    tax_compliance: 'Daňová shoda',
    tax_software: 'Daňový software',
    trading_platforms: 'Obchodní platformy',
    transaction_verification: 'Ověřování transakcí',
    treasury_systems: 'Pokladní systémy',
    underwriting_software: 'Software pro upisování',
    wealth_management: 'Správa majetku',

    // Životní prostředí & Vodohospodářství - Chybějící dovednosti
    eia: 'EIA (Posouzení vlivu na životní prostředí)',
    environmental_assessment: 'Environmentální hodnocení',
    environmental_protection: 'Ochrana životního prostředí',
    environmental_regulations: 'Environmentální předpisy',
    environmental_sampling: 'Environmentální vzorkování',
    iso_14001: 'ISO 14001',
    pump_operation: 'Obsluha čerpadel',
    water_chemistry: 'Chemie vody',
    water_engineering: 'Vodohospodářské inženýrství',
    water_quality_testing: 'Testování kvality vody',

    // Elektrotechnika & Elektronika - Chybějící dovednosti
    automation: 'Automatizace',
    circuit_design: 'Návrh obvodů',
    circuit_simulation: 'Simulace obvodů',
    circuit_testing: 'Testování obvodů',
    electrical_safety: 'Elektrická bezpečnost',
    electrical_wiring: 'Elektrické vedení',
    electronics_troubleshooting: 'Řešení problémů s elektronikou',
    ladder_logic: 'Žebříčková logika',
    scada_systems: 'SCADA systémy',
    testing_equipment: 'Testovací zařízení',

    // Vzdělávání & Školení - Chybějící dovednosti
    behavior_management: 'Řízení chování',
    behavioral_management: 'Behaviorální management',
    classroom_support: 'Podpora ve třídě',
    course_design: 'Návrh kurzů',
    curriculum_planning: 'Plánování učebních osnov',
    driving_instruction: 'Výuka jízdy',
    early_childhood_education: 'Vzdělávání v raném dětství',
    individualized_education_plans: 'Individuální vzdělávací plány',
    lms_platforms: 'LMS platformy',
    practical_instruction: 'Praktická výuka',
    scorm: 'SCORM',
    student_assistance: 'Pomoc studentům',
    student_mentoring: 'Mentorování studentů',
    teaching_methods: 'Vyučovací metody',
    traffic_regulations: 'Dopravní předpisy',
    training_techniques: 'Školící techniky',
    university_teaching: 'Univerzitní výuka',
    vehicle_operation: 'Ovládání vozidla',
    vocational_training: 'Odborné vzdělávání',
    workshop_management: 'Řízení workshopů',

    // Sítě & Telekomunikace - Chybějící dovednosti
    backup_procedures: 'Zálohovací procedury',
    bss_systems: 'BSS systémy',
    cctv_installation: 'Instalace CCTV',
    cisco_networking: 'Cisco sítě',
    coverage_planning: 'Plánování pokrytí',
    cybersecurity: 'Kybernetická bezpečnost',
    fiber_optics: 'Optická vlákna',
    fraud_detection: 'Detekce podvodů',
    incident_response: 'Reakce na incidenty',
    lte_5g: 'LTE/5G',
    mobile_networks: 'Mobilní sítě',
    network_modeling: 'Modelování sítí',
    network_operations: 'Síťové operace',
    network_planning: 'Plánování sítí',
    network_testing: 'Testování sítí',
    oss_systems: 'OSS systémy',
    penetration_testing: 'Penetrační testování',
    radio_network_optimization: 'Optimalizace rádiových sítí',
    radio_network_planning: 'Plánování rádiových sítí',
    rf_engineering: 'RF inženýrství',
    rf_planning: 'RF plánování',
    routing_switching: 'Směrování & Přepínání',
    signal_testing: 'Testování signálu',
    tcp_ip: 'TCP/IP',
    telecommunications_equipment: 'Telekomunikační zařízení',
    telecommunications_installation: 'Telekomunikační instalace',
    user_management: 'Správa uživatelů',
    virtualization: 'Virtualizace',
    windows_server: 'Windows Server',

    // Databáze - Chybějící dovednosti
    backup_recovery: 'Zálohování & Obnova',
    data_modeling: 'Datové modelování',
    database_optimization: 'Optimalizace databáze',
    query_optimization: 'Optimalizace dotazů',
    replication: 'Replikace',
    sql: 'SQL',
    sql_optimization: 'SQL optimalizace',

    // Věda & Výzkum - Chybějící dovednosti
    cataloging: 'Katalogizace',
    chromatography: 'Chromatografie',
    culture_methods: 'Kultivační metody',
    flow_cytometry: 'Průtoková cytometrie',
    gc_ms: 'GC-MS',
    geodesy: 'Geodézie',
    geospatial_analysis: 'Geoprostorová analýza',
    hplc: 'HPLC',
    information_retrieval: 'Vyhledávání informací',
    mass_spectrometry: 'Hmotnostní spektrometrie',
    mathematical_modeling: 'Matematické modelování',
    measurement_standards: 'Měřicí standardy',
    metrology: 'Metrologie',
    molecular_biology: 'Molekulární biologie',
    research_methods: 'Výzkumné metody',
    scientific_writing: 'Vědecké psaní',
    sterile_techniques: 'Sterilní techniky',
    western_blot: 'Western blot',

    // Stavebnictví & Výstavba - Chybějící dovednosti
    building_management: 'Správa budov',
    construction_economics: 'Stavební ekonomika',
    construction_planning: 'Plánování výstavby',
    construction_processes: 'Stavební procesy',
    construction_software: 'Stavební software',
    construction_supervision: 'Stavební dohled',
    construction_technology: 'Stavební technologie',
    drywall_installation: 'Instalace sádrokartonu',
    electrical_design: 'Návrh elektrických systémů',
    excavators: 'Rýpadla',
    fem_software: 'FEM software',
    flooring_installation: 'Instalace podlah',
    glass_calibration: 'Kalibrace skla',
    glass_cutting: 'Řezání skla',
    heavy_machinery: 'Těžké stroje',
    insulation_installation: 'Instalace izolace',
    joinery: 'Truhlářství',
    leak_detection: 'Detekce úniku',
    load_calculations: 'Výpočty zatížení',
    mep_design: 'MEP návrh',
    mortar_mixing: 'Míchání malty',
    pipe_fitting: 'Montáž potrubí',
    pipe_installation: 'Instalace potrubí',
    plumbing_design: 'Návrh instalací',
    quantity_takeoff: 'Výměr množství',
    rigging: 'Montáž a upevňování',
    roofing_installation: 'Instalace střechy',
    safety_management: 'Řízení bezpečnosti',
    scaffolding_erection: 'Stavění lešení',
    sheet_metal_work: 'Klempířské práce',
    structural_knowledge: 'Znalosti statiky',
    taping_finishing: 'Bandážování a finální úpravy',
    tile_setting: 'Kladení obkladů',
    window_installation: 'Instalace oken',
    windshield_replacement: 'Výměna čelního skla',
    wood_cutting: 'Řezání dřeva',

    // Marketing & Komunikace - Další chybějící dovednosti
    basic_analytics: 'Základní analytika',
    branding: 'Branding',
    campaign_development: 'Vývoj kampaní',
    campaign_strategy: 'Strategie kampaní',
    communication_platforms: 'Komunikační platformy',
    community_management: 'Správa komunity',
    content_optimization: 'Optimalizace obsahu',
    crisis_communication: 'Krizová komunikace',
    event_management: 'Řízení událostí',
    internal_communications: 'Interní komunikace',
    keyword_research: 'Výzkum klíčových slov',
    marketing_campaigns: 'Marketingové kampaně',
    marketing_knowledge: 'Marketingové znalosti',
    marketing_management: 'Marketingový management',
    marketing_strategy: 'Marketingová strategie',
    marketing_support: 'Marketingová podpora',
    media_buying: 'Nákup médií',
    media_planning: 'Plánování médií',
    media_software: 'Mediální software',
    online_marketing: 'Online marketing',
    ppc_campaigns: 'PPC kampaně',
    press_releases: 'Tiskové zprávy',
    social_media: 'Sociální média',
    social_media_advertising: 'Reklama na sociálních médiích',
    social_media_platforms: 'Platformy sociálních médií',
    technical_seo: 'Technické SEO',
    vendor_coordination: 'Koordinace dodavatelů',

    // Veřejná správa & Poštovní služby - Chybějící dovednosti
    citizen_services: 'Služby pro občany',
    mail_delivery: 'Doručování pošty',
    policy_implementation: 'Implementace politik',
    postal_regulations: 'Poštovní předpisy',
    procurement_law: 'Zákon o veřejných zakázkách',
    public_administration: 'Veřejná správa',
    public_procurement: 'Veřejné zakázky',
    regulatory_procedures: 'Regulační postupy',
    senior_advisory: 'Senior poradenství',
    senior_policy_advice: 'Senior politické poradenství',
    sorting: 'Třídění',
    tender_procedures: 'Veřejné soutěže',

    // Různé profesionální dovednosti - Chybějící dovednosti (Část 1)
    avionics: 'Avionika',
    basic_cooking: 'Základní vaření',
    basic_equipment: 'Základní zařízení',
    basic_math: 'Základní matematika',
    basic_mechanics: 'Základní mechanika',
    basic_patient_care: 'Základní péče o pacienty',
    basic_repairs: 'Základní opravy',
    basic_skills: 'Základní dovednosti',
    basic_technology: 'Základní technologie',
    basic_tools: 'Základní nástroje',
    beauty_treatments: 'Kosmetická ošetření',
    beverage_presentation: 'Prezentace nápojů',
    blacksmithing: 'Kovářství',
    blasting: 'Pískování',
    bodywork_alignment: 'Nastavení karoserie',
    boiler_operation: 'Obsluha kotlů',
    cabin_service: 'Kabinová služba',
    cable_installation: 'Instalace kabelů',
    call_center_management: 'Řízení call centra',
    call_center_operations: 'Operace call centra',
    call_center_software: 'Call center software',
    call_routing: 'Směrování hovorů',
    canvas_preparation: 'Příprava plátna',
    casino_games: 'Kasinové hry',
    cat_tools: 'CAT nástroje',
    chemical_safety: 'Chemická bezpečnost',
    childcare: 'Péče o děti',
    choreography: 'Choreografie',
    cleaning: 'Úklid',
    cleaning_equipment: 'Úklidová zařízení',
    client_advisory: 'Poradenství pro klienty',
    client_assessment: 'Hodnocení klientů',
    client_consultation: 'Konzultace s klienty',
    client_relationship: 'Vztahy s klienty',
    coaching_methods: 'Koučovací metody',
    communication_systems: 'Komunikační systémy',
    communications: 'Komunikace',
    complaint_handling: 'Vyřizování stížností',
    complaint_management: 'Řízení stížností',
    cooperative_management: 'Řízení družstva',
    country_management: 'Řízení země',
    craftsmanship: 'Řemeslná zručnost',
    crew_management: 'Řízení posádky',

    // Obchodní management & Plánování - Chybějící dovednosti
    business_development: 'Obchodní rozvoj',
    business_planning: 'Obchodní plánování',
    business_processes: 'Obchodní procesy',
    capacity_planning: 'Plánování kapacity',
    cmms_systems: 'CMMS systémy',
    coordination: 'Koordinace',
    demand_planning: 'Plánování poptávky',
    erp_systems: 'ERP systémy',
    facility_systems: 'Systémy zařízení',
    kpi_tracking: 'Sledování KPI',
    maintenance_coordination: 'Koordinace údržby',
    maintenance_management: 'Řízení údržby',
    performance_analysis: 'Analýza výkonu',
    performance_metrics: 'Metriky výkonu',
    performance_tracking: 'Sledování výkonu',
    process_analysis: 'Analýza procesů',
    process_management: 'Řízení procesů',
    product_management: 'Produktový management',
    purchasing_software: 'Nákupní software',
    requirement_analysis: 'Analýza požadavků',
    requirement_gathering: 'Sběr požadavků',
    roadmap_planning: 'Plánování roadmap',
    sprint_planning: 'Plánování sprintů',
    supply_management: 'Řízení dodávek',
    system_analysis: 'Systémová analýza',
    vendor_negotiation: 'Vyjednávání s dodavateli',
    vendor_relations: 'Vztahy s dodavateli',

    // Technické & Vývoj - Chybějící dovednosti
    bug_tracking: 'Sledování chyb',
    cocoa_touch: 'Cocoa Touch',
    composer: 'Composer',
    data_processing: 'Zpracování dat',
    debugging: 'Ladění',
    expert_knowledge: 'Expertní znalosti',
    integration_patterns: 'Integrační vzory',
    junit: 'JUnit',
    markdown: 'Markdown',
    maven: 'Maven',
    microservices: 'Mikroslužby',
    pytest: 'PyTest',
    selenium: 'Selenium',
    system_architecture: 'Systémová architektura',
    technical_consultation: 'Technická konzultace',
    test_automation: 'Automatizace testování',
    test_cases: 'Testovací případy',
    testing: 'Testování',
    user_manuals: 'Uživatelské příručky',

    // Různé profesionální dovednosti - Chybějící dovednosti (Část 3)
    consecutive_interpreting: 'Konsekutivní tlumočení',
    cooking: 'Vaření',
    cutting_equipment: 'Řezací zařízení',
    cutting_tools: 'Řezací nástroje',
    design_principles: 'Principy designu',
    dmx_control: 'DMX ovládání',
    finishing: 'Dokončování',
    forging: 'Kování',
    fuel_dispensing: 'Výdej paliva',
    fur_working: 'Práce s kožešinami',
    gemstone_setting: 'Osazování drahokamů',
    geology: 'Geologie',
    gps_surveying: 'GPS průzkum',
    guest_reception: 'Přijímání hostů',
    hydrology: 'Hydrologie',
    ic_design: 'Návrh integrovaných obvodů',
    inspection_techniques: 'Inspekční techniky',
    modeling: 'Modelování',
    monitoring_control: 'Monitorování a kontrola',
    monitoring_equipment: 'Monitorovací zařízení',
    monitoring_visits: 'Monitorovací návštěvy',
    pedicure: 'Pedikúra',
    precision_tools: 'Přesné nástroje',
    pressure_testing: 'Tlakové testování',
    production_procedures: 'Výrobní postupy',
    production_supervision: 'Supervize výroby',
    semiconductor_technology: 'Polovodičová technologie',
    service_monitoring: 'Monitorování služeb',
    speed_efficiency: 'Rychlost a efektivita',
    styling: 'Styling',
    time_studies: 'Časové studie',
    tire_mounting: 'Montáž pneumatik',
    tire_pressure_monitoring: 'Monitorování tlaku v pneumatikách',
    tools_equipment: 'Nástroje a zařízení',
    tpms_systems: 'TPMS systémy',
    upholstery_techniques: 'Čalounické techniky',
    vhdl_verilog: 'VHDL/Verilog',
    wig_styling: 'Styling paruky',
    wood_engineering: 'Dřevařské inženýrství',
    wood_processing: 'Zpracování dřeva',
    wood_product_design: 'Design dřevěných produktů',
    wood_technology: 'Dřevařská technologie',

    // Různé profesionální dovednosti - Chybějící dovednosti (Část 2)
    consulting: 'Poradenství',
    consulting_methods: 'Metody poradenství',
    correspondence: 'Korespondence',
    counseling_techniques: 'Techniky poradenství',
    cultural_management: 'Kulturní management',
    cultural_programs: 'Kulturní programy',
    current_affairs: 'Aktuální dění',
    customer_advisory: 'Poradenství pro zákazníky',
    customer_communication: 'Komunikace se zákazníky',
    customer_consultation: 'Konzultace se zákazníky',
    customer_verification: 'Ověřování zákazníků',
    dance_techniques: 'Taneční techniky',
    data_recording: 'Zaznamenávání dat',
    data_verification: 'Ověřování dat',
    dealing_techniques: 'Techniky vyjednávání',
    dent_removal: 'Odstranění promáčklin',
    destination_knowledge: 'Znalosti destinací',
    detailing: 'Detailing',
    diagnostic_tools: 'Diagnostické nástroje',
    dishwashing: 'Mytí nádobí',
    documentation: 'Dokumentace',
    donor_management: 'Řízení dárců',
    ecological_surveying: 'Ekologický průzkum',
    economic_analysis: 'Ekonomická analýza',
    email_management: 'Správa e-mailů',
    english_translation: 'Anglický překlad',
    entertainment_programs: 'Zábavné programy',
    equipment_handling: 'Manipulace se zařízením',
    event_decoration: 'Dekorace akcí',
    exercise_programs: 'Cvičební programy',
    fabric_knowledge: 'Znalosti textilií',
    fashion_knowledge: 'Módní znalosti',
    fashion_software: 'Módní software',
    fem_analysis: 'FEM analýza',
    fitness_training: 'Fitness trénink',
    floor_care: 'Péče o podlahy',
    floral_design: 'Design květin',
    flower_arranging: 'Aranžování květin',
    following_instructions: 'Dodržování pokynů',
    frame_selection: 'Výběr rámů',
    front_desk_operations: 'Operace na recepci',
    front_desk_software: 'Recepční software',
    fur_treatment: 'Úprava kožešin',
    furniture_making: 'Výroba nábytku',
    furniture_repair: 'Oprava nábytku',
    gaming_regulations: 'Herní předpisy',
    geological_knowledge: 'Geologické znalosti',
    geological_surveying: 'Geologický průzkum',
    german_translation: 'Německý překlad',
    hair_coloring: 'Barvení vlasů',
    haircutting: 'Střihání vlasů',
    handyman_skills: 'Zručnosti údržbáře',
    hardware_support: 'Hardwarová podpora',
    height_work: 'Práce ve výškách',
    household_management: 'Správa domácnosti',
    hydraulic_design: 'Hydraulický návrh',
    hygiene_care: 'Hygienická péče',
    installation: 'Instalace',
    instrument_proficiency: 'Ovládání nástrojů',
    itinerary_planning: 'Plánování itinerářů',
    kitchen_cleaning: 'Čištění kuchyně',
    knowledge_base: 'Znalostní báze',
    labeling: 'Označování',
    land_surveying: 'Geodézie',
    language_proficiency: 'Jazyková zdatnost',
    language_skills: 'Jazykové dovednosti',
    laundry: 'Prádelna',
    leather_working: 'Práce s kůží',
    licensing_compliance: 'Dodržování licencí',
    literacy_review: 'Kontrola gramotnosti',
    maintenance: 'Údržba',
    makeup_techniques: 'Techniky líčení',
    manicure: 'Manikúra',
    manual_labor: 'Manuální práce',
    maritime_regulations: 'Námořní předpisy',
    materials_knowledge: 'Znalosti materiálů',
    mathematics: 'Matematika',
    measurement: 'Měření',
    mechanical_knowledge: 'Mechanické znalosti',
    mechatronics: 'Mechatronika',
    meeting_minutes: 'Zápis ze schůzky',
    metadata_cataloging: 'Katalogizace metadat',
    mining_equipment: 'Důlní zařízení',
    mining_operations: 'Důlní operace',
    mixed_media: 'Smíšená média',
    mobility_assistance: 'Pomoc s mobilitou',
    nail_care: 'Péče o nehty',
    navigation_equipment: 'Navigační zařízení',
    note_taking: 'Vytváření poznámek',
    nutrition_basics: 'Základy výživy',
    optimization: 'Optimalizace',
    packaging_equipment: 'Balicí zařízení',
    packaging_procedures: 'Balicí postupy',
    paint_booth_operation: 'Obsluha lakoven',
    painting_techniques: 'Techniky malování',
    panel_beating: 'Karosářství',
    paper_handling: 'Manipulace s papírem',
    patient_transport: 'Transport pacientů',
    pattern_cutting: 'Stříhání vzorů',
    performance: 'Výkon',
    personal_hygiene: 'Osobní hygiena',
    persuasive_writing: 'Přesvědčivé psaní',
    phone_systems: 'Telefonní systémy',
    physical_stamina: 'Fyzická vytrvalost',
    plant_knowledge: 'Znalosti rostlin',
    polishing_machines: 'Leštičky',
    preservation_techniques: 'Techniky konzervace',
    pressure_washer: 'Vysokotlaký čistič',
    problem_resolution: 'Řešení problémů',
    process_simulation: 'Simulace procesů',
    production_standards: 'Výrobní standardy',
    productivity_standards: 'Standardy produktivity',
    program_development: 'Vývoj programů',
    property_care: 'Péče o majetek',
    quality_sorting: 'Třídění kvality',
    registry_procedures: 'Registrační postupy',
    remote_desktop: 'Vzdálená plocha',
    reporting: 'Reportování',
    reservation_management: 'Správa rezervací',
    reservation_procedures: 'Rezervační postupy',
    robot_programming: 'Programování robotů',
    rope_access: 'Lanový přístup',
    salon_equipment: 'Salonové vybavení',
    sawmill_operation: 'Obsluha pily',
    scanning_systems: 'Skenovací systémy',
    scenic_design: 'Scénický design',
    sealant_application: 'Aplikace těsnících hmot',
    seating_coordination: 'Koordinace sedění',
    sewing_machines: 'Šicí stroje',
    ship_navigation: 'Lodní navigace',
    shoe_making: 'Výroba obuvi',
    signal_recognition: 'Rozpoznávání signálů',
    simulation_software: 'Simulační software',
    simulation_tools: 'Simulační nástroje',
    simultaneous_interpreting: 'Simultánní tlumočení',
    sociological_research: 'Sociologický výzkum',
    sop_compliance: 'Dodržování SOP',
    special_effects: 'Speciální efekty',
    sports_training: 'Sportovní trénink',
    staff_management: 'Řízení personálu',
    stage_presence: 'Scénická prezentace',
    standard_setting: 'Nastavování standardů',
    statistical_methods: 'Statistické metody',
    statistical_software: 'Statistický software',
    styling_software: 'Styling software',
    switchboard_operation: 'Obsluha ústředny',
    team_facilitation: 'Facilitace týmu',
    team_supervision: 'Supervize týmu',
    technical_analysis: 'Technická analýza',
    technical_calculations: 'Technické výpočty',
    technical_expertise: 'Technická expertiza',
    technical_knowledge: 'Technické znalosti',
    technical_management: 'Technický management',
    technical_procedures: 'Technické postupy',
    technical_processes: 'Technické procesy',
    technical_specifications: 'Technické specifikace',
    technical_troubleshooting: 'Technické řešení problémů',
    temperature_control: 'Regulace teploty',
    terminology_management: 'Správa terminologie',
    theater_technology: 'Divadelní technika',
    ticketing_systems: 'Systémy prodeje vstupenek',
    total_station: 'Totální stanice',
    travel_booking_systems: 'Systémy rezervace cestování',
    trend_analysis: 'Analýza trendů',
    trend_awareness: 'Povědomí o trendech',
    verification_procedures: 'Ověřovací postupy',
    vocal_techniques: 'Vokální techniky',
    wardrobe_management: 'Správa šatníku',
    watch_repair: 'Oprava hodinek',
    wheel_balancing: 'Vyvažování kol',
    work_measurement: 'Měření práce',
    workflow_planning: 'Plánování pracovních toků',

    // Prodej & Maloobchodní management - Chybějící dovednosti
    display_design: 'Design výlohy',
    e_commerce_platforms: 'E-commerce platformy',
    key_account_management: 'Správa klíčových účtů',
    phone_communication: 'Telefonní komunikace',
    product_expertise: 'Znalosti produktů',
    product_placement: 'Umístění produktů',
    product_presentation: 'Prezentace produktů',
    product_promotion: 'Propagace produktů',
    regional_management: 'Regionální management',
    retail_knowledge: 'Znalosti maloobchodu',
    sales_analysis: 'Analýza prodeje',
    sales_coaching: 'Koučování prodeje',
    sales_management: 'Řízení prodeje',
    sales_strategy: 'Prodejní strategie',
    sales_support: 'Podpora prodeje',
    sales_targets: 'Prodejní cíle',
    sales_techniques: 'Prodejní techniky',
    section_management: 'Řízení sekce',
    specialized_sales: 'Specializovaný prodej',
    store_management: 'Řízení prodejny',
    store_operations: 'Provoz prodejny',
    telemarketing: 'Telemarketing',
    territory_management: 'Správa území',
    upselling: 'Doplňkový prodej',
    visual_displays: 'Vizuální výlohy',

    // Bezpečnost, Ochrana & Záchranné služby - Chybějící dovednosti
    emergency_planning: 'Plánování nouzových situací',
    fire_codes: 'Požární předpisy',
    fire_prevention: 'Prevence požárů',
    fire_safety_systems: 'Požární bezpečnostní systémy',
    firearms_handling: 'Manipulace se střelnou zbraní',
    firefighting_equipment: 'Hasičské vybavení',
    hazmat_procedures: 'HAZMAT postupy',
    investigation_techniques: 'Vyšetřovací techniky',
    law_enforcement: 'Vymáhání práva',
    military_operations: 'Vojenské operace',
    military_tactics: 'Vojenské taktiky',
    navigation: 'Navigace',
    patrol_procedures: 'Postupy hlídkování',
    physical_training: 'Fyzický trénink',
    rescue_techniques: 'Záchranné techniky',
    safety_analysis: 'Bezpečnostní analýza',
    safety_inspection: 'Bezpečnostní inspekce',
    safety_standards: 'Bezpečnostní normy',
    security_management: 'Řízení bezpečnosti',
    security_procedures: 'Bezpečnostní postupy',
    surveillance: 'Dohled',
    swimming: 'Plavání',
    tactics: 'Taktiky',
    water_safety: 'Bezpečnost na vodě',
    weapons_handling: 'Manipulace se zbraněmi',

    // Výroba & Řízení kvality - Chybějící dovednosti
    calipers_micrometers: 'Posuvná měřidla & Mikrometry',
    cmm_operation: 'Obsluha CMM',
    defect_analysis: 'Analýza chyb',
    foundry_equipment: 'Slévárenská zařízení',
    grinding_machines: 'Brusky',
    iso_standards: 'ISO normy',
    lean_manufacturing: 'Lean výroba',
    machine_calibration: 'Kalibrace strojů',
    material_science: 'Materiálová věda',
    material_testing: 'Testování materiálů',
    measurement_tools: 'Měřicí nástroje',
    metal_casting: 'Lití kovů',
    metallurgical_processes: 'Metalurgické procesy',
    metallurgy: 'Metalurgie',
    milling_machines: 'Frézky',
    mold_making: 'Výroba forem',
    ndt_methods: 'NDT metody',
    production_machinery: 'Výrobní stroje',
    production_management: 'Řízení výroby',
    quality_monitoring: 'Monitorování kvality',
    quality_software: 'Software pro řízení kvality',
    six_sigma: 'Six Sigma',
    statistical_process_control: 'Statistické řízení procesů',
    tool_changing: 'Výměna nástrojů',
    tool_making: 'Výroba nástrojů',
    tool_setup: 'Nastavení nástrojů',
    turning_machines: 'Soustruhy',
    ultrasonic_testing: 'Ultrazvukové testování',
  },
};
